"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

exports.styles = function (_a) {
  var colorBgSecondary = _a.colorBgSecondary,
      sizeAvatarXS = _a.sizeAvatarXS,
      colorIconSecondary = _a.colorIconSecondary,
      sizeIconUI = _a.sizeIconUI;
  return {
    chip: {
      padding: '0px 8px 0px 2px',
      height: 28,
      cursor: 'pointer',
      border: 'none',
      outline: 'none',
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: 16,
      overflow: 'hidden',
      backgroundColor: colorBgSecondary.normal,
      '&:hover, &$hover': {
        background: colorBgSecondary.hover
      },
      '&:focus, &$focus': {
        background: colorBgSecondary.active
      },
      '&:active, &$active': {
        background: colorBgSecondary.active
      }
    },
    active: {},
    hover: {},
    focus: {},
    avatar: {
      height: sizeAvatarXS,
      paddingTop: 2,
      paddingBottom: 2
    },
    text: {
      paddingLeft: 8,
      paddingRight: 8,
      maxWidth: '250px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    square: {
      borderRadius: 0
    },
    crossWrapper: {
      height: sizeIconUI + "px",
      width: sizeIconUI + "px",
      '& > svg': {
        fill: colorIconSecondary.normal
      },
      '&:hover > svg': {
        fill: colorIconSecondary.active
      }
    }
  };
};